/* rockkt-kind-words-v2 (15 Oct 2026). Drives the "Kind words" section on the homepage
   (markup in snippets/rockkt-kind-words-v2.liquid, styles in rockkt-kind-words-v2.css).
   v2 (Glen): shorter. No filters and no ticker; tighter spacing round the ring. The list
   is visually hidden once this runs but stays in the page for search and screen readers.

   Reads the quotes from the server-rendered list, so the list is the only copy of the
   words. Builds:
     - the hologram card (one quote at a time, decoded in like a signal)
     - the projector ring under it: one node per quote, coloured by kind, drifting slowly.
       Click a node, drag the ring, or use the arrows; the chosen node swings to the front
       and a light beam joins it to the card.
   Auto-advances every 7 seconds while the section is on screen, with a pause button
   (WCAG 2.2.2). Screen readers hear a quote only when the visitor changed it.
   Reduced motion: no drift, no decode; starts paused (Play still works).
   No fetch, no storage, no third parties. */
(function () {
  var root = document.getElementById('kind-words');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && matchMedia('(pointer: fine)').matches;
  var PANEL = root.querySelector('.kw-panel');
  var LIST = root.querySelector('.kw-list');
  var LIS = [].slice.call(LIST.children);
  if (!LIS.length) return;

  var KIND = {
    gift:   { tag: 'Gift received',   icon: '<path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' },
    sample: { tag: 'Sample received', icon: '<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>' },
    idea:   { tag: 'First reaction',  icon: '<path d="M12 3l1.8 4.7 4.7 1.8-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M19 15l.7 1.8 1.8.7-1.8.7L19 20l-.7-1.8-1.8-.7 1.8-.7z"/>' },
    client: { tag: 'Rockkt client',   icon: '<path d="M5 12.5l4.5 4.5L19 7.5"/>' }
  };

  var Q = LIS.map(function (li, i) {
    var k = KIND[li.getAttribute('data-k')] ? li.getAttribute('data-k') : 'idea';
    return { i: i, k: k, q: (li.querySelector('q') || li).textContent.trim(), who: (li.querySelector('.kw-w') || {}).textContent || '', li: li };
  });

  function svg(path, cls) {
    return '<svg viewBox="0 0 24 24"' + (cls ? ' class="' + cls + '"' : '') + ' aria-hidden="true">' + path + '</svg>';
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- build ---------- */
  root.classList.add('kw-js');

  var stage = document.createElement('div');
  stage.className = 'kw-stage';
  stage.innerHTML =
    '<svg class="kw-beam" aria-hidden="true"><defs><linearGradient id="kwBeamG" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#5fd4ff" stop-opacity=".55"/><stop offset=".7" stop-color="#8f7bff" stop-opacity=".12"/><stop offset="1" stop-color="#8f7bff" stop-opacity="0"/></linearGradient></defs><polygon fill="url(#kwBeamG)"/><line stroke="#9ee6ff" stroke-width="1.2" stroke-opacity=".8"/></svg>' +
    '<figure class="kw-holo">' +
      '<div class="kw-card">' +
        '<span class="kw-scan" aria-hidden="true"></span>' +
        '<div class="kw-hud"><span class="kw-tag"><i></i><span></span></span><span class="kw-num"><span class="kw-sig">Signal </span><b>01</b> / <span class="kw-tot">27</span></span></div>' +
        '<blockquote class="kw-q"><p aria-hidden="true"></p></blockquote>' +
        '<figcaption class="kw-who"></figcaption>' +
        '<div class="kw-ctl">' +
          '<button type="button" class="kw-prev" aria-label="Previous quote">' + svg('<path d="M15 18l-6-6 6-6"/>') + '</button>' +
          '<button type="button" class="kw-pp" aria-label="Pause the quotes">' + svg('<path d="M9 5v14M15 5v14"/>', 'pa') + svg('<path d="M7 4.5v15l12-7.5z"/>', 'pl') + '</button>' +
          '<button type="button" class="kw-next" aria-label="Next quote">' + svg('<path d="M9 18l6-6-6-6"/>') + '</button>' +
          '<span class="kw-bar" aria-hidden="true"><i></i></span>' +
        '</div>' +
        '<p class="kw-sr" aria-live="polite"></p>' +
      '</div>' +
    '</figure>' +
    '<div class="kw-ring" aria-hidden="true">' +
      '<svg class="kw-ell"><defs><radialGradient id="kwPool"><stop offset="0" stop-color="#5fd4ff" stop-opacity=".22"/><stop offset="1" stop-color="#5fd4ff" stop-opacity="0"/></radialGradient></defs><ellipse class="e3"/><ellipse class="e2"/><ellipse class="e1"/></svg>' +
    '</div>' +
    '<p class="kw-hint" aria-hidden="true">' + (FINE ? 'Drag the ring or pick a signal' : 'Swipe the ring or tap a signal') + '</p>';

  var head = root.querySelector('.kw-head');
  head.parentNode.insertBefore(stage, head.nextSibling);
  LIST.setAttribute('aria-label', 'All quotes');

  var holo = stage.querySelector('.kw-holo'), card = stage.querySelector('.kw-card');
  var ring = stage.querySelector('.kw-ring'), ell = ring.querySelectorAll('ellipse');
  var beam = stage.querySelector('.kw-beam'), poly = beam.querySelector('polygon'), line = beam.querySelector('line');
  var qP = card.querySelector('.kw-q p'), who = card.querySelector('.kw-who'), sr = card.querySelector('.kw-sr');
  var tag = card.querySelector('.kw-tag'), tagT = tag.querySelector('span');
  var numB = card.querySelector('.kw-num b'), numT = card.querySelector('.kw-tot');
  var bar = card.querySelector('.kw-bar i'), pp = card.querySelector('.kw-pp');

  var NODES = Q.map(function (x) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kw-node';
    b.tabIndex = -1;
    b.setAttribute('data-k', x.k);
    b.setAttribute('data-i', x.i);
    b.innerHTML = svg(KIND[x.k].icon);
    ring.appendChild(b);
    return b;
  });

  /* ---------- geometry ---------- */
  var G = {};
  function measure() {
    var w = stage.clientWidth, small = w < 640;
    var ns = small ? 24 : 38;
    var rx = Math.min(small ? w * 0.46 : w * 0.45, 470), ry = small ? 32 : 56;
    var rh = ry * 2 + ns + 12;
    stage.style.setProperty('--kw-ns', ns + 'px');
    stage.style.setProperty('--kw-rh', rh + 'px');
    /* card height: the longest quote decides, so the card never jumps between quotes */
    card.style.setProperty('--kw-ch', '0px');
    var keep = qP.textContent, keepCls = qP.className, hmax = 0;
    Q.forEach(function (x) { qP.className = x.q.length > 130 ? 'kw-long' : ''; qP.textContent = x.q; hmax = Math.max(hmax, card.offsetHeight); });
    qP.textContent = keep; qP.className = keepCls;
    card.style.setProperty('--kw-ch', hmax + 'px');
    var gap = small ? 26 : 34;
    var sh = 18 + hmax + gap + rh + 22;
    stage.style.setProperty('--kw-sh', sh + 'px');
    G = { w: w, rx: rx, ry: ry, ns: ns, rh: rh, cx: w / 2, cy: ry + ns / 2 + 6, sh: sh,
          ringTop: sh - 22 - rh, cardBottom: 18 + hmax, cardL: (w - Math.min(660, w)) / 2, cardW: Math.min(660, w) };
    beam.setAttribute('viewBox', '0 0 ' + w + ' ' + sh);
    for (var e = 0; e < ell.length; e++) {
      ell[e].setAttribute('cx', G.cx); ell[e].setAttribute('cy', G.cy);
      var f = e === 1 ? 0.78 : 1;
      ell[e].setAttribute('rx', G.rx * f); ell[e].setAttribute('ry', G.ry * f);
    }
  }

  /* ---------- state ---------- */
  var vis = Q.slice(), cur = 0, base = Math.PI / 2, target = null;
  var paused = RM, hover = false, inView = false, drag = null, timer = null, T = 7000, TAU = Math.PI * 2;

  function step() { return TAU / vis.length; }
  function slotOf(qi) { for (var s = 0; s < vis.length; s++) if (vis[s].i === qi) return s; return -1; }

  function place() {
    var st = step(), act = Q[cur], ax = 0, ay = 0;
    for (var s = 0; s < vis.length; s++) {
      var a = base + s * st, x = G.cx + G.rx * Math.cos(a), y = G.cy + G.ry * Math.sin(a);
      var d = (Math.sin(a) + 1) / 2;
      var n = NODES[vis[s].i];
      n.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + (0.55 + 0.45 * d).toFixed(3) + ')';
      n.style.opacity = (0.3 + 0.7 * d).toFixed(3);
      n.style.zIndex = Math.round(d * 100);
      n.style.filter = d < 0.35 ? 'blur(1px)' : '';
      if (vis[s] === act) { ax = x; ay = y + G.ringTop; }
    }
    var l = G.cardL + 40, r = G.cardL + G.cardW - 40, t = G.cardBottom - 2;
    poly.setAttribute('points', ax.toFixed(1) + ',' + ay.toFixed(1) + ' ' + l + ',' + t + ' ' + r + ',' + t);
    line.setAttribute('x1', ax.toFixed(1)); line.setAttribute('y1', ay.toFixed(1));
    line.setAttribute('x2', (G.cardL + G.cardW / 2).toFixed(1)); line.setAttribute('y2', t);
  }

  var conic = 0;
  function frame() {
    if (target !== null) {
      var df = target - base;
      base += df * 0.09;
      if (Math.abs(df) < 0.0008) { base = target; target = null; }
    } else if (!drag && !RM && !hover) {
      base += 0.0011;
    }
    if (!RM) { conic = (conic + 0.6) % 360; card.style.setProperty('--kw-a', conic + 'deg'); }
    place();
    if (!RM && inView) requestAnimationFrame(frame); else running = false;
  }
  var running = false;
  function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }

  /* ---------- decode ---------- */
  var GLYPHS = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%&*+<>/=';
  var dec = 0;
  function decode(s) {
    var id = ++dec;
    if (RM) { qP.textContent = s; return; }
    var F = 26, f = 0;
    /* if animation frames are paused (background tab), never leave scrambled text */
    setTimeout(function () { if (id === dec) { dec++; qP.textContent = s; } }, 900);
    (function tick() {
      if (id !== dec) return;
      f++;
      var r = Math.floor(s.length * f / F), out = s.slice(0, r), tail = '';
      for (var c = r; c < Math.min(s.length, r + 14); c++) tail += s.charAt(c) === ' ' ? ' ' : GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length));
      qP.innerHTML = '';
      qP.appendChild(document.createTextNode(out));
      if (r < s.length) {
        var g = document.createElement('span'); g.className = 'kw-g'; g.textContent = tail; qP.appendChild(g);
        var rest = s.slice(Math.min(s.length, r + 14));
        if (rest) { var h = document.createElement('span'); h.style.opacity = '0'; h.textContent = rest; qP.appendChild(h); }
        requestAnimationFrame(tick);
      }
    })();
  }

  /* ---------- show a quote ---------- */
  function show(qi, user) {
    cur = qi;
    var x = Q[qi], s = slotOf(qi);
    if (s < 0) return;
    var want = Math.PI / 2 - s * step();
    want += Math.round((base - want) / TAU) * TAU;
    if (RM) { base = want; } else { target = want; }
    qP.className = x.q.length > 130 ? 'kw-long' : '';
    decode(x.q);
    who.textContent = x.who;
    tagT.textContent = KIND[x.k].tag;
    tag.className = 'kw-tag kw-c-' + x.k;
    numB.textContent = pad(s + 1);
    numT.textContent = pad(vis.length);
    NODES.forEach(function (n, i) { n.classList.toggle('kw-act', i === qi); });
    sr.setAttribute('aria-live', user ? 'polite' : 'off');
    sr.textContent = '"' + x.q + '" ' + x.who + '. ' + KIND[x.k].tag + '.';
    restart();
    if (RM) place(); else kick();
  }
  function go(d, user) {
    var s = slotOf(cur);
    s = (s + d + vis.length) % vis.length;
    show(vis[s].i, user);
  }

  /* ---------- auto-advance ---------- */
  function restart() {
    clearTimeout(timer);
    bar.classList.remove('go');
    bar.style.width = '0';
    if (paused || !inView) return;
    void bar.offsetWidth;
    bar.style.width = '';
    root.style.setProperty('--kw-t', T + 'ms');
    bar.classList.add('go');
    timer = setTimeout(function () { if (!paused && !hover && inView && !document.hidden) go(1, false); else restart(); }, T);
  }
  function setPaused(p) {
    paused = p;
    root.classList.toggle('kw-paused', p);
    pp.setAttribute('aria-label', p ? 'Play the quotes' : 'Pause the quotes');
    restart();
  }

  /* ---------- events ---------- */
  stage.querySelector('.kw-prev').addEventListener('click', function () { go(-1, true); });
  stage.querySelector('.kw-next').addEventListener('click', function () { go(1, true); });
  pp.addEventListener('click', function () { setPaused(!paused); });
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1, true); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1, true); }
  });

  /* ring: click a node, or drag the ring and let go on the one at the front */
  ring.addEventListener('pointerdown', function (e) {
    drag = { x: e.clientX, b: base, moved: false, id: e.pointerId };
    target = null;
    ring.classList.add('kw-drag');
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 4) drag.moved = true;
    base = drag.b - dx * (2.6 / Math.max(G.w, 320));
    if (RM) place(); else kick();
  });
  window.addEventListener('pointerup', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag; drag = null;
    ring.classList.remove('kw-drag');
    if (!d.moved) {
      var n = e.target.closest && e.target.closest('.kw-node');
      if (n) { show(+n.getAttribute('data-i'), true); return; }
      restart(); return;
    }
    var s = Math.round((Math.PI / 2 - base) / step());
    s = ((s % vis.length) + vis.length) % vis.length;
    show(vis[s].i, true);
  });
  window.addEventListener('pointercancel', function () { if (drag) { drag = null; ring.classList.remove('kw-drag'); go(0, false); } });

  /* tilt and spotlight, mouse only */
  if (FINE && !RM) {
    PANEL.addEventListener('pointermove', function (e) {
      var r = PANEL.getBoundingClientRect();
      PANEL.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      PANEL.style.setProperty('--my', (e.clientY - r.top) + 'px');
      var h = holo.getBoundingClientRect();
      var px = (e.clientX - (h.left + h.width / 2)) / r.width, py = (e.clientY - (h.top + h.height / 2)) / r.height;
      holo.style.setProperty('--ry', (px * 7).toFixed(2) + 'deg');
      holo.style.setProperty('--rx', (-py * 6).toFixed(2) + 'deg');
    });
    PANEL.addEventListener('pointerleave', function () { holo.style.setProperty('--rx', '0deg'); holo.style.setProperty('--ry', '0deg'); });
  }
  stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
  stage.addEventListener('pointerleave', function () { hover = false; });
  stage.addEventListener('focusin', function () { hover = true; });
  stage.addEventListener('focusout', function () { hover = false; });

  /* only animate while on screen */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (x) { inView = x.isIntersecting; if (inView) { kick(); restart(); } else { clearTimeout(timer); } });
    }, { threshold: 0.2 }).observe(stage);
  } else { inView = true; }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) restart(); });

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); place(); }, 150); });

  measure();
  if (paused) root.classList.add('kw-paused');
  show(0, false);
  place();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); place(); });
})();
